import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class TaxRuntimeService {
  private baseUrl = `${environment.apiUrl}/api/taxruntime`   ;
  constructor(
    private http: HttpClient
  ) {}

  resolve(payload: any) {
    let url =`${this.baseUrl}/resolve`;

    return this.http.post<any>(
      url,
      payload
    );
  }
}